export default {
  "fr": {
    "announcement": {
      "actions": {
        "delete_announcement": "Supprimer Annonce",
        "edit": "Modifier",
        "new": "Nouvelle annonce",
        "save": "Sauvegarder",
        "submit": "Poster"
      },
      "attributes": {
        "description": "Description"
      },
      "labels": {
        "change_announcement_levels": "Modifier les niveaux d'annonce",
        "customers": "",
        "for": "pour les clients",
        "image_tab": "Image",
        "now": "Présent",
        "partiallyShared": "{project_name} (limité partagé)",
        "start": "Début",
        "unitsCount": "Une Unité | {count} Unités",
        "video_tab": "vidéo",
        "youtube_video": "Lien Vidéo YouTube"
      },
      "name": "Annonce",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Bientôt, vous trouverez des annonces sur le site de construction sur le dashboard.",
            "title": "Recevez vos nouvelles ici!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Accueillir vos clients ou partagez une mise à jour sur le projet.",
            "title": "Créer votre première Annonce"
          },
          "none": {
            "project_required": "Sélectionnez un projet",
            "subtitle": "Accueillez vos clients ou partagez une mise à jour sur n'importe quel projet."
          },
          "paste_video_url": "Coller votre lien YouTube ici"
        }
      },
      "toasts": {
        "create": "Annonce publiée",
        "delete": "Annonce supprimée",
        "invalid_video": "Ce n'est pas une vidéo YouTube valide",
        "update": "Annonce modifiée"
      },
      "validation": {
        "pleaseAddContent": "Ajouter une image, une vidéo ou description"
      }
    }
  }
}